export const SOURCES = {OMNETIC: 'OMNETIC', XENTRY: 'XENTRY'} as const;
